/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

export class InputValidator {
  errorMessages = {
    emptyField: "Dieses Feld muss ausgefüllt werden.",
    invalidEmail: "Diese E-Mail-Adresse ist ungültig.",
    invalidPassword: "Muss mindestens 6 Zeichen lang sein.",
  };
  value: string | number;
  type: InputType;
  required: boolean;
  errorMessage = "";
  validators = {
    [InputType.TEXT]: this.isTextValueValid(),
    [InputType.EMAIL]: this.isEmailValid(),
    [InputType.PASSWORD]: this.isPasswordValid(),
  };

  constructor(value: string | number, type: InputType, required: boolean) {
    this.value = value;
    this.type = type;
    this.required = required;
  }

  updateValue(value: string | number){
    this.value = value;
  }

  isValid(): boolean {
    if(this.required && !this.hasValue()) {//input is required and has no value
      this.errorMessage = this.errorMessages.emptyField;
      return false;
    }
    switch (this.type) {
      case InputType.EMAIL:
        if(!this.isEmailValid()) {
          this.errorMessage = this.errorMessages.invalidEmail;
          return false;
        }
        break;
      case InputType.PASSWORD:
        if(!this.isPasswordValid()) {
          this.errorMessage = this.errorMessages.invalidPassword;
          return false;
        }
        break;
    }
    this.errorMessage = "";
    return true;
  }

  private hasValue(): boolean {
    return !!this.value && this.value.toString().length > 0;
  }

  private isTextValueValid(): boolean {
    return true;
  }

  private isEmailValid(): boolean {
    if(!this.hasValue()) return true;//return true to skip the next check
    return !!this.value.toString().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
  }

  private isPasswordValid(): boolean {
    if(!this.hasValue()) return true; //return true to skip the next check
    return this.value.toString().length >= 6;
  }

  getErrorMessage(): string {
    return this.errorMessage;
  }

  isRequired(): boolean {
    return this.required;
  }
}

export enum InputType {
  TEXT,
  EMAIL,
  PASSWORD,
  NUMBER
}